

export default () => {
	function progressBarScroll () {
		let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
		let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		let scrolled = ( winScroll / height ) * 100;

		document.getElementById( 'js-scroll-bar' ).style.width = `${scrolled}%`;
	}

	window.onscroll = function () {
		progressBarScroll();
	};
};
